export const RETURN_MODES = Object.freeze({
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
});
